module.exports = __webpack_public_path__ + "img/videowall_alt.7f92cd72.webp";